import { BaseService } from "services/_baseService";

class RolesAdminService extends BaseService<any> {
  constructor() {
    super(`roles`);
  }
}

export default new RolesAdminService();
